import React from 'react'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faChartLine } from '@fortawesome/free-solid-svg-icons'
import { CurrencyFormat } from '../../../helpers/formatting'

const AccountOverviewCard = ({ selectedAccount, accountOptions, selectedAccountIndex, onAccountChange }) => (
  <div className="box mb-4 ml-2 mr-2">
    <div className="columns">
      <div className="column is-6">
        <div className="is-flex is-align-items-center mb-4">
          <FontAwesomeIcon icon={faBuilding} className="mr-2 has-text-info" />
          <div>
            <h3 className="title is-4 mb-1">
              {selectedAccount?.name} {selectedAccount?.institution_code ? `- ${selectedAccount.institution_code}` : ''}
            </h3>
            <p className="subtitle is-6 has-text-grey mt-1">
              {selectedAccount?.type} • {selectedAccount?.account_number}
              {selectedAccount?.is_closed && <span className="tag is-light ml-2">Closed</span>}
            </p>
          </div>
        </div>

        <div className="content is-small">
          <p><strong>Routing Number:</strong> {selectedAccount?.routing_number || '-'}</p>
          <p><strong>Currency:</strong> {selectedAccount?.currency_code || '-'}</p>
        </div>

        <label className="label mt-4" htmlFor="chirp-account-select">Select Account</label>
        <Select
          inputId="chirp-account-select"
          options={accountOptions}
          value={accountOptions[selectedAccountIndex]}
          onChange={onAccountChange}
          isSearchable={false}
          placeholder="Choose an account..."
          styles={{
            menu: ({ ...css }) => ({ ...css, width: '100%', zIndex: 20 })
          }}
        />
      </div>

      <div className="column is-6">
        <h4 className="title is-6 mb-3">
          <FontAwesomeIcon icon={faChartLine} className="mr-2" />
          Balance
        </h4>
        <p className="title is-3">{CurrencyFormat({ value: selectedAccount?.balance })}</p>
        <div className="content is-small">
          <p><strong>Available Balance:</strong> {CurrencyFormat({ value: selectedAccount?.available_balance })}</p>
        </div>
      </div>
    </div>
  </div>
)

export default AccountOverviewCard
